export default function () {
  return {
    drawerState: true,
    currAssessmentState: {}
  }
}
